import React from 'react';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import {
  FDBox,
  FDPrimaryActionButton,
  FDStack,
  FDTitleText,
  FDTransferList,
} from '@facet-wealth/design';
import { DialogActions, DialogContent } from 'Views/Page/Content/Modal/Components';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import MetaLayoutRemainingFields from 'Components/UI/Meta/MetaForm/Components/MetaLayout/MetaLayoutRemainingFields';
import useMobileLayout from 'Hooks/useMobileLayout';
import { dataAttrs, testAttr } from 'Helpers/Testing';
import { currency } from 'Helpers/Formats';

const Layout = () => {
  const {
    resource, onSubmit, saving, handleChange, consumeAttr,
  } = useMetaLayoutContext();
  const isMobile = useMobileLayout();

  const options = resource.metaField('irreducible').options().list().map(option => option.export());

  const reducibleValues = consumeAttr('reducible');
  const irreducibleValues = consumeAttr('irreducible');

  const reducibleExpenses = resource.attr('expenses').resources().list().filter(expense => reducibleValues.includes(expense.id()));
  const irreducibleExpenses = resource.attr('expenses').resources().list().filter(expense => irreducibleValues.includes(expense.id()));

  const reducibleExpenseTotal = reducibleExpenses.reduce((acc, expense) => acc + Number(expense.attr('amount')), 0);
  const irreducibleExpenseTotal = irreducibleExpenses.reduce((acc, expense) => acc + Number(expense.attr('amount')), 0);

  const reducibleSectionTitle = `${resource.metaField('reducible').attr('prompt')} - ${currency(reducibleExpenseTotal, true)}`;
  const irreducibleSectionTitle = `${resource.metaField('irreducible').attr('prompt')} - ${currency(irreducibleExpenseTotal, true)}`;

  return (
    <>
      <MetaControlField attr="title" />
      <DialogContent scrollKey={resource?.type() + resource?.id()}>
        <FDStack direction={'column'} alignItems={'stretch'} spacing={1}>
          <MetaControlField attr={'subtitle'} />
          <FDTransferList
            options={options}
            value={consumeAttr('irreducible')}
            // This next line isn't just nice for testing, it's also important for marking irreducible as being rendered so that MetaLayoutRemainingFields doesn't render it
            {...dataAttrs('bulk-irreducibile-input', { [testAttr.dataValue]: consumeAttr('irreducible').join('_') })}
            vertical={isMobile}
            firstHeader={(
              <FDBox padding={2}>
                <FDTitleText size="lg" value={irreducibleSectionTitle} />
              </FDBox>
            )}
            secondHeader={(
              <FDBox padding={2}>
                <FDTitleText size="lg" value={reducibleSectionTitle} />
              </FDBox>
            )}
            onChange={(values) => {
              handleChange('irreducible', values);
              const rightValues = options.map(option => option.id).filter(option => !values.includes(option));
              handleChange('reducible', rightValues);
            }}
          />
          <MetaLayoutRemainingFields />
        </FDStack>
      </DialogContent>
      <DialogActions>
        <FDStack wrap spacing={1} alignItems="center">
          <FDPrimaryActionButton
            loading={saving}
            onClick={onSubmit}
            {...dataAttrs('continue-btn', resource)}
            label="Continue →"
          />
        </FDStack>
      </DialogActions>
    </>
  );
};

export default Layout;
